import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/reportesbi/reportes',
  documento: 'reportesbi',
  acceso: 'sesion',
  filas: ['115'],
  cita: 'Areas/ReportesBI/Controllers/ReportesController.cs',
} satisfies RutaProd;
